import { AxiosError } from 'axios';

import type { DetailError } from '@quick/go-api-types/common';

import { standardError } from './standardError';

export default function msgFromAxiosException(error: unknown) {
  let err: unknown;
  const isAxios = error instanceof AxiosError;
  if (isAxios) {
    err =
      (error.response?.data as DetailError)?.detail ??
      error.response?.data ??
      error.message;
  } else {
    err = (error as Error)?.message ?? error;
  }
  return { msg: standardError(err), isAxios };
}
